import { REGIONS, PREFECTURES } from 'Src/me/pages/guest/proposals/new/consts';
import type { BaseAnswerType } from '../../../views/types';

export const PREFECTURE_BY_REGION = REGIONS.reduce((accumulator, region) => {
  accumulator[region.name] = PREFECTURES
    .filter((prefecture) => prefecture.regionId === region.id)
    .sort((a, b) => a.regionOrder - b.regionOrder)
    .map((prefecture) => ({
      id: prefecture.id,
      value: prefecture.name,
    })) as BaseAnswerType[];

  return accumulator;
}, {} as { [region: string]: BaseAnswerType[] });
